module.exports = __webpack_public_path__ + "static/media/WorkNestLogo.ffe8726f.svg";